import { render, staticRenderFns } from "./Gotop.vue?vue&type=template&id=71f4dc6e&"
import script from "./Gotop.vue?vue&type=script&lang=js&"
export * from "./Gotop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports